<template>
  <transition name="gl-fade">
    <div v-if="active" class="gl-overlay">
      <div class="gl-box">
        <div class="gl-spinner">
          <div class="gl-ring"></div>
          <div class="gl-ring gl-ring--delay"></div>
        </div>
        <span class="gl-text">Loading…</span>
      </div>
    </div>
  </transition>
</template>

<script>
import { loaderState } from '@/services/loader'

export default {
  name: 'GlobalLoader',
  computed: {
    active () { return loaderState.active }
  }
}
</script>

<style scoped>
.gl-overlay {
  position: fixed; inset: 0; z-index: 9999;
  background: rgba(15, 23, 42, 0.5);
  display: flex; align-items: center; justify-content: center;
}
.gl-box {
  background: #fff; border-radius: 16px;
  padding: 32px 40px;
  display: flex; flex-direction: column; align-items: center; gap: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
  min-width: 140px;
}
.gl-spinner {
  position: relative; width: 44px; height: 44px;
}
.gl-ring {
  position: absolute; inset: 0;
  border: 3px solid transparent;
  border-top-color: #c8960c;
  border-radius: 50%;
  animation: gl-spin 0.8s linear infinite;
}
.gl-ring--delay {
  border-top-color: #8b5e3c;
  animation-duration: 1.2s;
  animation-direction: reverse;
}
.gl-text {
  font-size: 13px; font-weight: 600; color: #64748b;
  font-family: 'Open Sans', sans-serif; letter-spacing: 0.3px;
}
.gl-fade-enter-active, .gl-fade-leave-active { transition: opacity 0.2s ease; }
.gl-fade-enter, .gl-fade-leave-to { opacity: 0; }

@keyframes gl-spin {
  to { transform: rotate(360deg); }
}
</style>
